<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <panel-title icon="mdi-format-list-text" :desc="$t('YAZILAR.LIST.SUB_TITLE')">
          <template v-slot:title>
            <span class="mr-5">{{ $t("YAZILAR.LIST.TITLE") }}</span>
            <div>
              <v-btn dark :to="`${$route.path}/yazi-ekle`" small color="pink darken-1" class="mr-4">
                <v-icon size="18" left>mdi-plus-thick</v-icon>
                {{ $t("YAZILAR.LIST.ADD_POST_BTN") }}
              </v-btn>
              <v-btn dark :to="`${$route.path}/kategoriler`" small outlined color="pink darken-1" class="mr-4">
                <v-icon left>mdi-tag-multiple</v-icon>
                {{ $t("YAZILAR.LIST.CATEGORIES_NAV_BTN") }}
              </v-btn>
            </div>
            <div>
              <language-selector v-model="currentLang" :flag="false" icon-color="grey darken-2" class="mr-2" />
            </div>
          </template>
          <template v-slot:append-inner>
            <v-col class="px-0 mt-5">
              <v-card color="transparent" elevation="0">
                <v-text-field
                  solo
                  :hint="$t('YAZILAR.SEARCHBOX.SEARCH_HINT')"
                  dense
                  :label="$t('YAZILAR.SEARCHBOX.SEARCH_LABEL')"
                  prepend-inner-icon="mdi-magnify"
                  class="yazi-ara-text-field font-weight-light mb-0"
                  v-model="yaziAraData.yaziAraText"
                  @keyup.enter="yaziAraEnter"
                  clearable
                >
                  <template v-slot:append>
                    <div class="d-flex align-center">
                      <v-btn depressed icon class="yazi-ara-btn" color="pink darken-1" @click="yaziAraEnter">
                        <v-icon color="pink darken-1">mdi-chevron-right</v-icon>
                      </v-btn>
                    </div>
                  </template>
                </v-text-field>
              </v-card>
            </v-col>
          </template>
          <template v-slot:append-inner-subtitle>
            <v-spacer></v-spacer>
            <v-card v-show="secilenYazilar.length > 0" color="transparent" elevation="0">
              <v-menu offset-y left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-on="on" v-bind="attrs" small color="primary" class="text-capitalize px-4">
                    {{ $t("YAZILAR.LIST.MASS_SELECTION.MASS_SELECTION_BTN") }}
                    <v-icon size="23" right>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item class="mb-1" link dense @click="topluYayinaAl">
                    <v-icon color="success" left>mdi-check</v-icon>
                    {{ $t("YAZILAR.LIST.MASS_SELECTION.PUBLISH_ALL_BTN") }}
                  </v-list-item>
                  <v-list-item class="mb-1" link dense @click="topluTaslakOlarakKaydet">
                    <v-icon color="warning" left>mdi-file-outline</v-icon>
                    {{ $t("YAZILAR.LIST.MASS_SELECTION.SET_ALL_AS_DRAFT") }}
                  </v-list-item>
                  <v-list-item class="mb-1" link dense @click="yazilariKaldirDialog">
                    <v-icon color="red" left>mdi-delete</v-icon>
                    {{ $t("YAZILAR.LIST.MASS_SELECTION.DELETE_ALL") }}
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card>
          </template>
        </panel-title>
      </v-col>
    </v-row>
    <v-data-table
      checkbox-color="pink darken-1"
      v-model="secilenYazilar"
      :items="yaziListesi"
      :page.sync="tableParams.page"
      :items-per-page="list.limit"
      :headers="yazilarTable.headers"
      :no-data-text="yazilarTable.noDataText"
      calculate-widths
      hide-default-footer
      class="elevation-1 mb-3"
      @page-count="tableParams.pageCount = $event"
      :loading="tableParams.listStatus"
      :loading-text="yazilarTable.loadingText"
      :server-items-length="yaziSayisi"
      show-select
    >
      <template v-slot:[`item.name`]="{ item }">
        <span class="font-weight-medium">{{ item.name }}</span>
      </template>
      <template v-slot:[`item.author`]="{ item }">
        <span class="grey--text text--darken-3">{{ item.author }}</span>
      </template>
      <template v-slot:[`item.date`]="{ item }">
        <span class="grey--text text--darken-3 font-weight-bold text-caption">{{ dateFormat(item.date) }}</span>
      </template>
      <template v-slot:[`item.publish`]="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              rounded
              v-if="item.publish === 1"
              color="success"
              x-small
              class="text-capitalize pr-1"
              depressed
              :loading="yayinDurumuLoading[item.code]"
            >
              {{ $t("YAZILAR.LIST.STATUSES.PUBLISHED") }}
              <v-icon size="15" dark>mdi-chevron-down</v-icon>
            </v-btn>
            <v-btn v-on="on" v-bind="attrs" rounded v-else color="warning" x-small class="text-capitalize pr-1" depressed :loading="yayinDurumuLoading[item.code]">
              {{ $t("YAZILAR.LIST.STATUSES.DRAFT") }}
              <v-icon size="15" dark>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-card elevation="0">
            <v-btn v-if="item.publish === 1" small color="warning" text class="text-capitalize" @click="taslakOlarakKaydet(item.code)">
              <v-icon small color="warning" left>mdi-file</v-icon>
              {{ $t("YAZILAR.LIST.ACTIONS.SET_AS_DRAFT_BTN") }}
            </v-btn>
            <v-btn v-else small color="success" text class="text-capitalize" @click="yayinaAl(item.code)">
              <v-icon small color="success" left>mdi-check</v-icon>
              {{ $t("YAZILAR.LIST.ACTIONS.SET_AS_PUBLISHED_BTN") }}
            </v-btn>
          </v-card>
        </v-menu>
      </template>
      <template v-slot:[`item.code`]="{ item }">
        <v-tooltip bottom color="pink darken-1 white--text">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" fab x-small color="grey lighten-2" class="elevation-0 mr-2" :to="`${$route.path}/yazi-duzenle/${item.code}?lang=${currentLang.code}`">
              <v-icon small color="grey darken-3">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("YAZILAR.LIST.ACTIONS.EDIT_POST_BTN") }}</span>
        </v-tooltip>

        <v-tooltip bottom color="red darken-4 white--text">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" fab x-small color="red lighten-4" class="elevation-0" @click="yaziyiKaldirDialog(item.code)">
              <v-icon small color="red darken-4">mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("YAZILAR.LIST.ACTIONS.DELETE_POST_BTN") }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-pagination v-model="pagination.page" :length="tableParams.pageCount" circle @input="pageClick"></v-pagination>

    <v-dialog v-model="yaziKaldir.dialog" max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>
          {{ $t("YAZILAR.LIST.DELETE_POST_DIALOG.TITLE") }}
        </v-card-title>
        <v-card-text>{{ $t("YAZILAR.LIST.DELETE_POST_DIALOG.INFO_CONTENT") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="yaziKaldir.dialog = false">
            {{ $t("YAZILAR.LIST.DELETE_POST_DIALOG.CANCEL_BTN") }}
          </v-btn>
          <v-btn color="green darken-1" text :loading="yaziKaldir.loading" @click="yaziyiKaldir()">
            {{ $t("YAZILAR.LIST.DELETE_POST_DIALOG.YES_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="yazilariKaldir.dialog" max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>
          {{ $t("YAZILAR.LIST.DELETE_POSTS_DIALOG.TITLE") }}
        </v-card-title>
        <v-card-text>{{ $t("YAZILAR.LIST.DELETE_POSTS_DIALOG.INFO_CONTENT") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="yazilariKaldir.dialog = false">
            {{ $t("YAZILAR.LIST.DELETE_POSTS_DIALOG.CANCEL_BTN") }}
          </v-btn>
          <v-btn color="green darken-1" text :loading="yazilariKaldir.loading" @click="topluOlarakKaldir()">
            {{ $t("YAZILAR.LIST.DELETE_POSTS_DIALOG.YES_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import PanelTitle from "../../../components/PanelTitle.vue";
import LanguageSelector from "@/components/Base/LanguageSelector.vue";
import YazilarService from "@/services/YazilarService.js";
import _ from "lodash";

export default {
  components: { PanelTitle, LanguageSelector },
  name: "YaziListesi",
  data() {
    return {
      currentLang: null,
      yazilarTable: {
        headers: [
          { text: this.$t("YAZILAR.LIST.TABLE_FIELDS.TITLE"), value: "name", sortable: false, width: 370 },
          { text: this.$t("YAZILAR.LIST.TABLE_FIELDS.AUTHOR"), value: "author", sortable: false },
          { text: this.$t("YAZILAR.LIST.TABLE_FIELDS.DATE"), value: "date", sortable: false },
          { text: this.$t("YAZILAR.LIST.TABLE_FIELDS.STATUS"), value: "publish", sortable: false },
          { text: this.$t("YAZILAR.LIST.TABLE_FIELDS.ACTIONS"), value: "code", sortable: false }
        ],
        noDataText: this.$t("YAZILAR.LIST.NO_POSTS_ADDITIONAL"),
        loadingText: this.$t("YAZILAR.LIST.LOADING_POSTS"),
        yaziListesi: []
      },
      secilenYazilar: [],
      pagination: {
        page: 1,
        lastPage: 0
      },
      tableParams: {
        page: 1,
        pageCount: 0,
        listStatus: true
      },
      list: {
        baslangic: 0,
        limit: 10
      },
      listStatus: true,
      yaziKaldir: {
        yaziCode: 0,
        dialog: false,
        loading: false
      },
      yazilariKaldir: {
        yaziCodes: 0,
        dialog: false,
        loading: false
      },
      yaziAraData: {
        yaziAraSelect: "",
        yaziAraText: "",
        yaziAraType: "name"
      },
      yayinDurumuLoading: []
    };
  },
  computed: {
    ...mapState({
      yaziListesi: state => state.Yazilar.YaziListesi.yaziListesi,
      yaziSayisi: state => state.Yazilar.YaziListesi.yaziSayisi
    })
  },
  methods: {
    yaziyiKaldir() {
      const yaziCode = this.yaziKaldir.yaziCode;
      this.yaziKaldir.loading = true;
      YazilarService.yaziyiKaldir({ yaziCode })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("YAZILAR.NOTIFY.POST_DELETE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.yaziKaldir.dialog = false;
            this.aktifDurumNesnesi();
            return (this.listStatus = true);
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.yaziKaldir.loading = false;
        });
    },
    yaziyiKaldirDialog(yaziCode) {
      this.yaziKaldir.yaziCode = yaziCode;
      this.yaziKaldir.dialog = true;
    },
    depthLine(length) {
      let lines = "";
      for (let i = 0; i < length; i++) {
        lines += "—";
      }
      return lines;
    },
    dateFormat(date) {
      return new Intl.DateTimeFormat(this.$store.state.Language.apiLanguage, {
        dateStyle: "long",
        timeStyle: "short"
      }).format(new Date(date));
    },
    yayinaAl(yaziCode) {
      this.yayinDurumuLoading[yaziCode] = true;
      YazilarService.yayinaAl({ yaziCode }).then(res => {
        if (res.status === 200) {
          let yaziListesi = this.yaziListesi;
          let sayfaList = _.map(yaziListesi, o => {
            if (o.code === yaziCode) {
              o.publish = 1;
            }
            return o;
          });
          this.$store.commit("Yazilar/YaziListesi/setYaziListesi", sayfaList);
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
        this.yayinDurumuLoading[yaziCode] = false;
      });
    },
    taslakOlarakKaydet(yaziCode) {
      this.yayinDurumuLoading[yaziCode] = true;
      YazilarService.taslakOlarakKaydet({ yaziCode }).then(res => {
        if (res.status === 200) {
          let yaziListesi = this.yaziListesi;
          let sayfaList = _.map(yaziListesi, o => {
            if (o.code === yaziCode) {
              o.publish = 0;
            }
            return o;
          });
          this.$store.commit("Yazilar/YaziListesi/setYaziListesi", sayfaList);
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
        this.yayinDurumuLoading[yaziCode] = false;
      });
    },
    pageClick(page) {
      if (page !== this.pagination.lastPage) {
        /**
         * Başlangıç değerini pagination'a göre ayarla
         */
        this.list.baslangic = this.pagination.page * this.list.limit - this.list.limit;

        if (!this.yaziAraData.yaziAraText) {
          /**
           * Ürün listesini getir
           */
          this.getYaziListesi();
        } else {
          /**
           * Arama var ise aramaya göre pagination getir
           */

          /**
           * Ürünü aram sonucunu pagination'a göre getir
           */
          this.yaziAra();
        }
      }
    },
    yaziAraEnter() {
      if (this.yaziAraData.yaziAraText !== "") this.paginationSifirla();

      this.yaziAra();
    },
    /**
     * Durum filtresinden birisi seçildiğinde
     * istek at
     */
    aktifDurumFiltresi() {
      this.paginationSifirla();
      this.getYaziListesi();
    },
    paginationSifirla() {
      this.$store.commit("Yazilar/YaziListesi/setYaziListesi", []);
      this.$store.commit("Yazilar/YaziListesi/setYaziSayisi", 0);
      this.list.baslangic = 0;
      this.pagination.page = 1;
    },
    aktifDurumNesnesi() {
      if (!this.yaziAraData.yaziAraText) {
        this.getYaziListesi();
      } else {
        this.yaziAra();
      }
    },
    getYaziListesi() {
      const { baslangic, limit } = this.list;
      return this.$store
        .dispatch("Yazilar/YaziListesi/getYaziListesi", {
          baslangic,
          limit,
          lang: this.currentLang.code
        })
        .then(res => {
          this.tableParams.listStatus = false;
          this.pagination.paginationLength = res.data.count;
          return res;
        })
        .then(res => {
          if (res.data.list.length === 0 && this.pagination.page > 1) {
            this.pageClick((this.pagination.page -= 1));
          }
        });
    },
    yaziAra() {
      const ara = this.yaziAraData.yaziAraText;
      const { baslangic, limit } = this.list;
      this.listStatus = true;
      return this.$store
        .dispatch("Yazilar/YaziListesi/yaziAra", {
          ara,
          baslangic,
          limit
        })
        .then(res => {
          this.listStatus = false;
          if (res.status !== 200) {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
          return res;
        })
        .then(res => {
          if (res.data.list.length === 0 && this.pagination.page > 1) {
            this.pageClick((this.pagination.page -= 1));
          }
        });
    },
    topluYayinaAl() {
      const yaziCodes = _.map(this.secilenYazilar, o => o.code);
      YazilarService.topluYayinaAl({ yaziCodes }).then(res => {
        if (res.status === 200) {
          let yaziListesi = this.yaziListesi;
          let sayfaList = _.map(yaziListesi, o => {
            if (yaziCodes.includes(o.code)) {
              o.publish = 1;
            }
            return o;
          });
          this.$store.commit("Yazilar/YaziListesi/setYaziListesi", sayfaList);
          this.$snotify.success(this.$t("YAZILAR.NOTIFY.POSTS_PUBLISH_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          this.secilenYazilar = [];
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
      });
    },
    topluTaslakOlarakKaydet() {
      const yaziCodes = _.map(this.secilenYazilar, o => o.code);
      YazilarService.topluTaslakOlarakKaydet({ yaziCodes }).then(res => {
        if (res.status === 200) {
          let yaziListesi = this.yaziListesi;
          let sayfaList = _.map(yaziListesi, o => {
            if (yaziCodes.includes(o.code)) {
              o.publish = 0;
            }
            return o;
          });
          this.$store.commit("Yazilar/YaziListesi/setYaziListesi", sayfaList);
          this.$snotify.success(this.$t("YAZILAR.NOTIFY.POSTS_SET_AS_DRAFT_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          this.secilenYazilar = [];
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
      });
    },
    topluOlarakKaldir() {
      const yaziCodes = this.yazilariKaldir.yaziCodes;
      this.yazilariKaldir.loading = true;
      YazilarService.topluOlarakKaldir({ yaziCodes })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("YAZILAR.NOTIFY.POSTS_DELETE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.yazilariKaldir.dialog = false;
            this.aktifDurumNesnesi();
            return (this.listStatus = true);
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.secilenYazilar = [];
          this.yazilariKaldir.loading = false;
        });
    },
    yazilariKaldirDialog() {
      this.yazilariKaldir.yaziCodes = _.map(this.secilenYazilar, o => o.code);
      this.yazilariKaldir.dialog = true;
    }
  },
  watch: {
    "pagination.page": {
      handler(page) {
        this.pagination.lastPage = page;
      },
      immediate: true
    },
    "yaziAraData.yaziAraText"(val) {
      if (!val) {
        this.list.baslangic = 0;
        this.getYaziListesi();
        this.yaziAraData.yaziAraSelect = "";
        // Clearable'da null'a çevirmekte, null dönerse "" at
        this.yaziAraData.yaziAraText = val ?? "";
      }
    },
    currentLang() {
      /**
       * Widget Listelerini Getir
       */
      this.getYaziListesi();
    }
  }
};
</script>

<style>
.yazi-ara-text-field.v-text-field .v-input__slot {
  margin-bottom: 0;
}

.yazi-ara-text-field.v-text-field {
  position: relative;
}

.yazi-ara-text-field.v-text-field .v-text-field__details {
  position: absolute;
  left: -10px;
  top: -18px;
  margin-bottom: 0;
  height: 0;
  width: 100%;
}
</style>
